import { Image } from "@chakra-ui/react";

export default function BrandLogo() {
  return (
    <Image src="https://tmetric.com/images/v3/tmetric_logo_with_text.svg" />
  );
}
